import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HelpService } from './help.service';

import { AddHelpCategoryDto, HelpPageFileDto, HelpSortOrdersDto, Tree, TreeNode, TreeOrderNodes } from './help.module';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpCategoryDto, HelpPageDto, HelpPageNewDto } from 'src/app/models/help-new';
import { ListElement } from 'src/app/models/list-element';
import { AuthService } from 'src/app/services';
import { UserRoleEnum } from 'src/app/enums/userRoleEnum';
import { Title } from '@angular/platform-browser';
import { ListService } from 'src/app/services/list.service';
import { ListElementEnum } from 'src/app/enums/listElementEnum';
import { InfoBoxService } from 'src/app/services/info-box.service';
import { DxTreeListComponent, DxTreeListTypes } from 'devextreme-angular/ui/tree-list';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { NotificationService } from 'src/app/services/notification.service';
@Component({
  selector: 'app-help-test',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  standalone: false
})
export class HelpNewComponent implements OnInit {
  [x: string]: any;
  @Input() class: string;
  @Input() controlName: string;
  @Input() disabled: boolean;
  @Output() onPageClick = new EventEmitter();
  @Output() onSearchPanelTextChange = new EventEmitter();
  @Output() onClose = new EventEmitter();
  pages: HelpCategoryDto[];
  Searchpages: HelpCategoryDto[]
  SearchWord: HelpCategoryDto[] = []
  pageData: Record<number, HelpPageDto> | undefined;
  selectedPageId: number;
  treeSearchText: string = "";
  focusedRowKey: number;
  formEdit: FormGroup;
  categoriesDataSource: { categoryId: number; name: string }[];
  createNewPage: boolean = false;
  isEditMode: boolean = false;
  searchWordsTextField: string = "";
  searchedByWordsPages: HelpPageDto[] = [];
  helpTypes: ListElement[] = [];
  isAdmin: boolean;
  searchWords: string;
  searchWordsEdit: string;
  Type: string;
  Editor: string;
  HtmlText: any;
  PageName: string;
  selectedPageName: string;
  files: any;
  helpfiles: any[] = [];
  Popfiles: any[] = [];
  tree: Tree[] = [];
  expandedRowKeys: number[] = [];
  selectedRowKeys: number[] = [];
  canAdd: boolean = true;
  isNotPage: boolean = true;
  categories: { [key: number]: HelpCategoryDto };
  title = "Add New Page";
  VisibleList: boolean = false;
  VisibleTreeList: boolean = true;
  isDeleted: boolean = false;
  //treeList: DxTreeListComponent;
  @ViewChild("treeList", { static: false }) dxTreeList: DxTreeListComponent
  form = this._fb.group({
    name: [undefined, [Validators.required, Validators.maxLength(500)]],
    typeId: [undefined],
    searchWords: [undefined, Validators.maxLength(500)],
    link: [undefined, Validators.maxLength(255)],
    HtmlText: [undefined],
    categoryId: [undefined, Validators.required],

  });

  controls = {
    name: this.form.get("name"),
    typeId: this.form.get("typeId"),
    searchWords: this.form.get("searchWords"),
    link: this.form.get("link"),
    HtmlText: this.form.get("HtmlText"),
    categoryId: this.form.get("categoryId"),
  };

  allowEdit: boolean;
  typeId: any;
  link: string;
  categoryId: number;
  IsActive: any;
  isPageId: any = 0;

  private readonly _idQueryParamName: string = "id";
  constructor(private _helpService: HelpService,
    private _authService: AuthService,
    private titleService: Title,
    private _listService: ListService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _route: ActivatedRoute,
    private _router: Router,
    private _location: Location,
    private _infoBoxService: InfoBoxService,
    private _notificationService: NotificationService,
    private _fb: FormBuilder, private elementRef: ElementRef) { }

  ngOnInit(): void {

    this.GetCategory('Pageload');


    this.isAdmin = this._authService.currentRole === UserRoleEnum.Admin;
    this.titleService.setTitle("Help");

    const $this = this;

    this._listService
      .GetListElements(ListElementEnum.HelpTypes)
      .subscribe((res) => {
        this.helpTypes = res;
        this._changeDetectorRef.markForCheck();
        this._route.queryParamMap.subscribe(
          (queryParams) => {
            const id: number = +queryParams.get($this._idQueryParamName);

            console.log(`ngOnInit-> initializeActivitiesObjectClientIds - ${$this._idQueryParamName}:`, id);

            if (id) {
              this.LoadHelpData(id);
            }
          }
        );
      });


  }


  GetCategory(type) {
    if (type == 'Pageload') {
      this._helpService.GetCategory().subscribe(
        (data) => {
          this.pages = data.table;
          this.hideLoader();
          this.dxTreeList.instance.repaint();
          this.dxTreeList.instance.refresh();
        }
      );
      this._helpService.GetCategoriesRecordNew().subscribe(
        ({ categories }) => {
          this.categories = categories;
          this._changeDetectorRef.markForCheck();
          this.categoriesDataSource = Object.values(this.categories)
            .filter((cat) => !!cat.parentCategoryId)
            .map((cat) => ({
              categoryId: cat.categoryId,
              name: `${this.categories[cat.parentCategoryId].name} > ${cat.name}`,
            })).sort((a, b) => a.name.localeCompare(b.name));

        }
      );
    }
    else {
      this.pages = this.Searchpages;
      this.dxTreeList.instance.repaint();
      this.dxTreeList.instance.refresh();
      this.hideLoader();
    }
    this.hideLoader();
  }
// Having issue while moving Section from above to below 
  // onReorderTree = (e: {
  //   dropInsideItem: boolean;
  //   toIndex: number;
  //   component: any;
  //   itemData: TreeNode;
  //   toComponent: any;
  //   fromIndex: number;
  // }) => {
  //   const tree = this.pages;
  //   if (e?.toIndex != null) {
  //     let categoryId = e.toComponent.getKeyByRowIndex(e.toIndex);
  //     let categoryIdOld = e.toComponent.getKeyByRowIndex(e.fromIndex);

  //     let items = this.pages.find(x => x.categoryId == categoryId);

  //     const sourceIndex = tree.findIndex(x => x.categoryId == categoryIdOld);
  //     tree.splice(sourceIndex, 1);
  //     let targetIndex = tree.findIndex(x => x.categoryId == categoryId) + 1;
  //     let itemDataIndex = e.itemData;

  //     if (itemDataIndex.isPageId && items && items.isPageId
  //       && itemDataIndex.parentcategoryId == items.parentCategoryId) {

  //     }
  //     else if (itemDataIndex.isPageId && items?.isPageId) {
  //       itemDataIndex.parentcategoryId = items.parentcategoryId;
  //     }
  //     else if (itemDataIndex.isPageId && items && (
  //       items.parentcategoryId == itemDataIndex.parentcategoryId
  //       || items.categoryId == itemDataIndex.categoryId)) {
  //       targetIndex = targetIndex - 1;
  //     }
  //     else if (!itemDataIndex.isPageId && items && (
  //       items.parentcategoryId == itemDataIndex.parentcategoryId
  //       || items.categoryId == itemDataIndex.categoryId)) {
  //       targetIndex = targetIndex - 1;
  //     }
  //     else if (itemDataIndex.isPageId && items && items.parentcategoryId != 0) {
  //       itemDataIndex.parentcategoryId = items.categoryId;
  //     }

  //     else if (!itemDataIndex.isPageId && itemDataIndex.parentcategoryId != 0) {
  //       if (items && items.parentcategoryId == 0) {
  //         itemDataIndex.parentcategoryId = items.categoryId;
  //       }
  //       else if (items?.isPageId) {
  //         let itemChild = this.pages.find(x => x.categoryId = items.parentcategoryId);
  //         if (itemChild?.parentCategoryId) {
  //           itemDataIndex.parentcategoryId = itemChild.parentCategoryId;
  //         }
  //       }
  //       else if (items && itemDataIndex.parentcategoryId != items.parentcategoryId) {
  //         itemDataIndex.parentcategoryId = items.parentcategoryId;
  //       }
  //     }
  //     tree.splice(targetIndex, 0, e.itemData);
  //   }

  //   this.dxTreeList.dataSource = tree;
  //   e.component.refresh();
  //   setTimeout(() => {
  //     this.getDataInSequence();
  //   }, 1000);



  // };

// modified to handle all issues while reordering
onReorderTree = (e: {
    dropInsideItem: boolean;
    toIndex: number;
    component: any;
    itemData: TreeNode;
    toComponent: any;
    fromIndex: number;
  }) => {
    const tree = this.pages;
    if (e?.toIndex != null) {
      let categoryId = e.toComponent.getKeyByRowIndex(e.toIndex);
      let categoryIdOld = e.toComponent.getKeyByRowIndex(e.fromIndex);

      let items = this.pages.find(x => x.categoryId == categoryId);

      const sourceIndex = tree.findIndex(x => x.categoryId == categoryIdOld);
      tree.splice(sourceIndex, 1);
      let targetIndex = tree.findIndex(x => x.categoryId == categoryId) + 1;
      let itemDataIndex = e.itemData;

      if (itemDataIndex.isPageId && items && items.isPageId
        && itemDataIndex.parentcategoryId == items.parentCategoryId) {

      }
      else if (itemDataIndex.isPageId && items?.isPageId) {
        itemDataIndex.parentcategoryId = items.parentcategoryId;
        if(e.toIndex < e.fromIndex){ //added to handle reordering issue when moved from above to below as we splice the tree from above no need to decrement index
            targetIndex = targetIndex - 1;
        }
      }
      else if (itemDataIndex.isPageId && items &&  (
        items.parentcategoryId == itemDataIndex.parentcategoryId
        || items.categoryId == itemDataIndex.categoryId)) {
          if(e.toIndex < e.fromIndex){ // added to handle reordering issue when moved from above to below as we splice the tree from above no need to decrement index
            targetIndex = targetIndex - 1;
          }
      }
      else if (!itemDataIndex.isPageId && items && (
        items.parentcategoryId == itemDataIndex.parentcategoryId
        || items.categoryId == itemDataIndex.categoryId)) {
          if(e.toIndex < e.fromIndex){ // added to handle reordering issue when moved from above to below as we splice the tree from above no need to decrement index
            targetIndex = targetIndex - 1;
          }
      }
      else if (itemDataIndex.isPageId && items && items.parentcategoryId != 0) {
        itemDataIndex.parentcategoryId = items.categoryId;
        
      }

      else if (!itemDataIndex.isPageId && itemDataIndex.parentcategoryId != 0) {
        if (items && items.parentcategoryId == 0) {
          itemDataIndex.parentcategoryId = items.categoryId;
        }
        else if (items?.isPageId) {
          let itemChild = this.pages.find(x => x.categoryId = items.parentcategoryId);
          if (itemChild?.parentCategoryId) {
            itemDataIndex.parentcategoryId = itemChild.parentCategoryId;
          }
        }
        else if (items && itemDataIndex.parentcategoryId != items.parentcategoryId) {
          itemDataIndex.parentcategoryId = items.parentcategoryId;
        }
      }
      tree.splice(targetIndex, 0, e.itemData);
    }

    this.dxTreeList.dataSource = tree;
    e.component.refresh();
    setTimeout(() => {
      this.getDataInSequence();
    }, 1000);



  };

  onDragChange(e: DxTreeListTypes.RowDraggingChangeEvent) {

  }

  showLoader(): void {
    if (this.dxTreeList && this.dxTreeList.instance) {
      // Show the loading indicator
      this.dxTreeList.instance.beginCustomLoading('Loading...');
    }
  }

  hideLoader(): void {
    if (this.dxTreeList && this.dxTreeList.instance) {
      // Hide the loading indicator
      this.dxTreeList.instance.endCustomLoading();
    }
  }


  // Method to get the data
  getDataInSequence(): void {
    this.dxTreeList.instance.repaint();
    this.dxTreeList.instance.refresh();
    const treeListInstance = this.dxTreeList.instance;
    let dataInSequence: TreeOrderNodes[] = [];
    this.showLoader();
    // Get all root nodes
    if (treeListInstance && treeListInstance.getRootNode() && treeListInstance.getRootNode().children) {
      const rootNodes = treeListInstance.getRootNode().children;
      if (rootNodes) {
        let orderByLevel0 = 0;
        rootNodes.forEach(node0Items => {
          let itemLevel0: TreeOrderNodes = new TreeOrderNodes();
          itemLevel0.key = node0Items.key;
          itemLevel0.IsParentCategoryId = node0Items.data["isParentCategoryId"];
          itemLevel0.categoryId = node0Items.data["categoryId"];
          itemLevel0.helpPageId = node0Items.data["helpPageId"];
          itemLevel0.isActive = node0Items.visible;
          itemLevel0.level = node0Items.level;
          itemLevel0.orderby = orderByLevel0;
          itemLevel0.parentcategoryId = node0Items.data["parentcategoryId"];
          let orderByLevel1 = 0;
          node0Items.children.forEach(node1Items => {

            let itemLevel1: TreeOrderNodes = new TreeOrderNodes();
            itemLevel1.key = node1Items.key;
            itemLevel1.IsParentCategoryId = node1Items.data["isParentCategoryId"];
            itemLevel1.categoryId = node1Items.data["categoryId"];
            itemLevel1.helpPageId = node1Items.data["helpPageId"];
            itemLevel1.isActive = node1Items.visible;
            itemLevel1.level = node1Items.level;
            itemLevel1.orderby = orderByLevel1;
            itemLevel1.parentcategoryId = node1Items.data["parentcategoryId"];
            dataInSequence.push(itemLevel1);
            let orderByLevel2 = 0;
            node1Items.children.forEach(node2Items => {
              let itemLevel2: TreeOrderNodes = new TreeOrderNodes();
              itemLevel2.key = node2Items.key;
              itemLevel2.IsParentCategoryId = node2Items.data["isParentCategoryId"];
              itemLevel2.categoryId = node2Items.data["categoryId"];
              itemLevel2.helpPageId = node2Items.data["helpPageId"];
              itemLevel2.isActive = node2Items.visible;
              itemLevel2.level = node2Items.level;
              itemLevel2.orderby = orderByLevel2;
              itemLevel2.parentcategoryId = node2Items.data["parentcategoryId"];
              dataInSequence.push(itemLevel2);
              orderByLevel2 = orderByLevel2 + 1;
            });
            orderByLevel1 = orderByLevel1 + 1;
            //}
          });
          dataInSequence.push(itemLevel0);
          orderByLevel0 = orderByLevel0 + 1;
        });
      }
    }
    this.onReorderUpdate(dataInSequence);

  }

  private _saveOrder(nodes: TreeNode[]) {
    const nodesObj = nodes.reduce((obj, node) => {
      obj[node.key] = node;
      return obj;
    }, {});

    console.log(nodesObj, nodes, "************nodes*************");



  }

  onReorderUpdate(trees: TreeOrderNodes[]) {
    console.log(trees.filter(x => x.parentcategoryId == 25624));
    this._helpService.UpdateOrders(trees).subscribe(() => {
      this.GetCategory('Pageload');
      this._notificationService.success("Order saved.");

    });
  }

  onReorder(helpOrders: HelpSortOrdersDto, item: any) {
    this.getDataInSequence();

  }

  onRowClick(data: TreeNode) {
    this.isEditMode = false;
    this.isPageId = data.isPageId;

    if (data.isPageId) {

      let obj = data.helpPageId;
      this.categoryId = data.parentcategoryId;
      this.IsActive = data.isActive
      this.selectedPageId = data.helpPageId;
      this.focusedRowKey = obj;
      this.selectedPageName = data.name;
      this.LoadHelpData(obj);

    }
  }
  onItemClick(data: TreeNode) {
    this.isPageId = data.isPageId;
    if (data.isPageId) {
      let obj = data.helpPageId;
      this.categoryId = data.parentcategoryId;
      this.IsActive = data.isActive
      this.selectedPageId = data.helpPageId;
      this.focusedRowKey = obj;
      this.selectedPageName = data.name;
      this.LoadHelpData(obj);
    }



  }

  startEdit() {

    this.isEditMode = true;


    this.formEdit = this._fb.group({
      name: [this.PageName || ""],
      searchWords: [this.searchWords || ""],
      htmlText: [this.HtmlText || ""],
      link: [this.link || ""],
      typeId: [this.typeId || ""],
      categoryId: [this.categoryId || ""],
      pageId: [this.selectedPageId || ""],
      IsActive: [this.IsActive || ""],
      filesToUpload: [[]],
      files: [this.files || []]

    });

    this.formEdit.valueChanges.subscribe(console.log);

  }

  onRemoveFile(file: HelpPageFileDto) {
    file.isDeleted = !file.isDeleted;
    if (this.onChange) this.onChange(this.files);
  }
  stopEdit() {
    this.form.reset();
    this.isEditMode = false;
  }
  filterBySearchWords() {
    if (!this.searchWordsTextField) {
      this.VisibleList = false;
      this.VisibleTreeList = true;
    }

    if (!this.pages || !this.searchWordsTextField) return;
    this.selectedPageId = undefined;

    const term = this.searchWordsTextField.toLowerCase().trim();
    this.SearchWord = Object.values(this.pages).filter(
      (p) => p && p.searchWords && p.searchWords != '' && p.searchWords.toLowerCase().includes(term)
    );

    this.Searchpages = this.SearchWord;

    this.VisibleList = true;
    this.VisibleTreeList = false;

  }
  proceedingInfoPopup: boolean = false;
  deleteHelp() {
    this.proceedingInfoPopup = true;
  }

  isDeteleClick = false;
  deleteHelpSection() {
    this.proceedingInfoPopup = false;
    this._helpService.DeleteHelpSection(this.selectedPageId).subscribe((updatedCategory) => {
      this._infoBoxService.show({
        message: updatedCategory.msg,
      });
      this.GetCategory('Pageload');
      this.isDeteleClick = true;


    });
  }


  getVisiblePageIds() {
    const currentSequenceWithHierarchy = this.getCurrentSequenceWithHierarchy();
    const pageId = currentSequenceWithHierarchy.filter(x => x.isPageId == true);
    const selectedIds = pageId.map(({ helpPageId }) => helpPageId);
    return selectedIds;

  }

  // Function to get current sequence of objects with hierarchy
  getCurrentSequenceWithHierarchy(): any[] {

    const currentData = this.pages;
    const sequenceWithHierarchy: any[] = [];

    // Function to recursively traverse the tree structure
    function traverse(item: any, parentcategoryId: any = null) {
      const newItem = { ...item }; // Clone the item to avoid modifying the original data
      newItem.parentcategoryId = parentcategoryId; // Store parent ID for hierarchical structure
      sequenceWithHierarchy.push(newItem); // Add the item to the sequence

      // Recursively traverse children
      const children = currentData.filter((childItem: any) => childItem.parentcategoryId === item.categoryId);
      children.forEach((child: any) => traverse(child, item.categoryId));
    }

    // Traverse each root item
    const roots = currentData.filter((item: any) => item.parentcategoryId === 0);
    roots.forEach((root: any) => traverse(root));

    return sequenceWithHierarchy;
  }


  HelpPageDetails(PageId: number) {

    this.LoadHelpData(PageId);
  }

  isSelected(pageId: number) {
    return this.selectedPageId && this.selectedPageId === pageId;
  }
  onChangePage(id: number) {
    this._selectPage(id);
  }
  private _selectPage(id: number) {
    if (!this.pages) return;

    this.isEditMode = false;
    this.selectedPageId = id;


  }
  onPrev() {
    const visiblePageIds = this.getVisiblePageIds();
    const currentIndex = visiblePageIds.indexOf(this.selectedPageId);
    const prevPageId =
      visiblePageIds[
      (currentIndex - 1 + visiblePageIds.length) % visiblePageIds.length
      ];
    this.LoadHelpData(prevPageId);

  }

  helpCategoryId: number = 0;
  helpIsActive: boolean = true;
  LoadHelpData(PageId) {
    this.loading = true;
    this._helpService.GetPageDetails(PageId).subscribe((data) => {
      try {
        if (data != null && data.table != null) {
          this.searchedByWordsPages = data.table;
          let catData = this.searchedByWordsPages.find(x => x.name);
          this.searchWords = catData.searchWords;
          this.Type = catData.typeName;
          this.typeId = catData.typeId;
          this.Editor = catData.createdBy;
          this.HtmlText = catData.htmlText;
          this.PageName = catData.name;

          this.selectedPageId = PageId;
          this.expandedRowKeys = [catData.parentcategoryId, catData.categoryId, catData.pageId];
          this.link = catData.link;
          this.documentUrl = catData.documentUrl;
          this.selectedRowKeys = [catData.pageId];
          if (this.isEditMode) {
            this.startEdit();
          }
          this.helpCategoryId = catData.categoryId;
          this.helpIsActive = catData.isActive;
        }

        this.helpfiles = [];
        if (data != null && data.table1 != null) {
          this.helpfiles = data.table1 as HelpPageFileDto[];
        }
        const url = `help?${this._idQueryParamName}=${this.selectedRowKeys}`;
        this.isDeteleClick = false;
        this._location.replaceState(url);
        this.loading = false;
      } catch (e) {
      }
      this.loading = false;
    });
  }

  onNext() {
    const visiblePageIds = this.getVisiblePageIds();
    if (this.selectedPageId == undefined) {
      this.selectedPageId = 1;
    }
    const currentIndex = visiblePageIds.indexOf(this.selectedPageId);
    const nextPageId =
      visiblePageIds[(currentIndex + 1) % visiblePageIds.length];

    this.LoadHelpData(nextPageId);
  }
  onCreateNewPage(): void {
    if (this.form.invalid) {
      return;
    }

    let message = "Page successfully created!";
    let formData = this.form.value as HelpPageNewDto;
    formData.IsActive = true;
    formData.files = [];
    this._helpService.SavePage(formData, [])
      .subscribe((res) => {
        this._infoBoxService.show({
          message,
        });
        this.form.reset();
        this.GetCategory('Pageload');
        this.LoadHelpData(res.pageId);
        this.createNewPage = false;
      });
  }
  onSave({ filesToUpload, ...formValues }) {
    let message = "Page successfully created!";
    if (!this.createNewPage) {
      message = "Page successfully updated!";
      formValues = { ...formValues };
    }
    let formData = formValues as HelpPageNewDto;
    formData.categoryId = this.helpCategoryId;
    formData.IsActive = this.helpIsActive;
    formData.files = this.helpfiles;

    this._helpService
      .SavePage(formData, filesToUpload)
      .subscribe((res) => {
        this._infoBoxService.show({
          message,
        });

        setTimeout(() => { this.infoBoxService.hide(); }, 2000);

        this.LoadHelpData(res.pageId);

        this.createNewPage = false;
        this.form.reset();
        this.isEditMode = false;
      });
    this.pages = this.pages.map((page) => ({
      ...page,
      name: page.helpPageId == formData.pageId ? formData.name : page.name
    }))
    this.dxTreeList.instance.repaint();
    this.dxTreeList.instance.refresh();
  }
  FormReset() {


    // this.form.reset()
    this.createNewPage = false;
    this.controls = undefined;

  }

  _setCategory(OldId: Number, category: AddHelpCategoryDto) {
    this.GetCategory('Pageload');
  }

  onAddCategory(category: AddHelpCategoryDto) {
    category.isActive = true;
    let OldId = category.categoryId;
    if (typeof category.categoryId === 'number') {
    }
    else {
      category.categoryId = 0;
    }


    this._helpService.TestSaveCategory(category).subscribe((newCategory) => {
      this._setCategory(OldId, newCategory);

      this._infoBoxService.show({
        message: "Category successfully added!",
      });
    });
  }
  onRowRemoved(data: TreeNode) {


    this.onRemoveCategory({
      categoryId: data.categoryId,
      isActive: false,
      name: data.name,
    } as AddHelpCategoryDto);
  }
  onRemoveCategory(category: AddHelpCategoryDto) {
    this._helpService.TestSaveCategory(category).subscribe((updatedCategory) => {

      this._infoBoxService.show({
        message: "Category successfully removed!",
      });
      this._changeDetectorRef.markForCheck();
    });
  }
  onRowUpdated(data: TreeNode) {



    this.onUpdateCategory({
      categoryId: data.categoryId,
      name: data.name,
      isActive: data.isActive,
    } as AddHelpCategoryDto);
  }
  onUpdateCategory(category: AddHelpCategoryDto) {
    this._helpService.TestSaveCategory(category).subscribe((updatedCategory) => {

      this._infoBoxService.show({
        message: "Category successfully updated!",
      });
    });
  }

  allowAdding(e) {
    return e.row.data.parentcategoryId == 0;
  }

  allowDeleting(e) {
    return e.row.data.helpPageId == 0;
  }

  onEventContentReady(e) {
    console.log(e);

    const spanElement = this.elementRef.nativeElement.querySelector('.dx-icon-clear');
    if (spanElement) {
      spanElement.addEventListener('click', this.handleSpanClearClick.bind(this));
    }


  }


  handleSpanClearClick() {
    this.VisibleList = false;
    this.VisibleTreeList = true;
  }

}
